import { TutorialStep } from "..";

export const ClsMoveInspSteps: TutorialStep[] = [
  {
    target: "#insp-move-btn",
    content: `정제된 데이터셋이 됐다면 \n 하단의 버튼을 눌러 검사단계로 이동합니다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
